import React from 'react'

function FraudRuleSection({title, description}) {
    return (
        <li className="wql-card wql-rule">
            <div className="wql-rule-head">
                <svg width="44" height="44" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <circle cx="38" cy="38" r="38" fill="#fde4d3"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M39.94 30.0319C39.3877 30.0319 38.94 29.5842 38.94 29.0319V24H49.2786C50.3832 24 51.2786 24.8954 51.2786 26V39.7454C51.2786 47.0021 45.3959 52.8847 38.1393 52.8847C30.8827 52.8847 25 47.0021 25 39.7454V26C25 24.8954 25.8954 24 27 24H36.1937L32.234 34.6458C31.991 35.2992 32.4742 35.9945 33.1713 35.9945H36.3383C36.8906 35.9945 37.3383 36.4422 37.3383 36.9945V43.8531C37.3383 44.9679 38.887 45.2465 39.2756 44.2017L44.0443 31.3805C44.2874 30.7272 43.8041 30.0319 43.1071 30.0319H39.94Z" fill="#c2410c"/>
                </svg>
            </div>

            <h2 className="wql-rule-title">{title}</h2>
            <p className="wql-rule-text">{description}</p>
        </li>
    )
}

export default FraudRuleSection;
